<template>
    <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout>
                <v-flex xs12 sm6>
                    <div>
                        <v-btn @click="newPlibel" large color="primary">Nueva hoja</v-btn>
                    </div>
                </v-flex>
            </v-layout>
            <br>
            <br>
            <v-layout>
                <v-flex xs12 sm6 offset-sm1>
                    <v-select v-model="plibel" :items="this.listPlibel" @change="loadCalculate()" label="Historial" item-text="fecha"
                              return-object required></v-select>
                </v-flex>
            </v-layout>
            <br>
            <v-expansion-panel v-if="this.plibel!=null">
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 1. Información personal y laboral</div>
                    </template>
                    <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                            <v-data-table
                                    :items="this.plibel.informacionLaboral"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-left">
                                        <p v-if="props.item.tipo==0">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==4" class="font-weight-bold">{{props.item.label}}</p>
                                        <p v-if="props.item.tipo==20" class="font-weight-bold">a. Datos de filiación</p>
                                        <p v-if="props.item.tipo==21" class="font-weight-bold">Identificación: {{$store.state.patient.identification}}</p>
                                        <p v-if="props.item.tipo==22" class="font-weight-bold">Apellidos y nombres: {{$store.state.patient.firstLastName}} {{$store.state.patient.secondLastName}}  {{$store.state.patient.firstName}} {{$store.state.patient.secondName}} </p>
                                        <p v-if="props.item.tipo==23" class="font-weight-bold">Edad: {{$store.state.patient.age}}</p>
                                        <p v-if="props.item.tipo==24" class="font-weight-bold">Empresa: {{$store.state.patient.company.name}}</p>
                                        <p v-if="props.item.tipo==25" class="font-weight-bold">Puesto de trabajo: {{$store.state.patient.jobCompany}}</p>
                                    </td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    No se han encontrado resultados para "{{ search }}".
                                </v-alert>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <div> 2. Plibel</div>
                    </template>
                    <table border="1">
                        <thead>
                        <tr>
                            <th colspan="6" style="width: 782px;" bgcolor="#CCCCFF" align="center"><b>PLIBEL LISTA DE
                                CHEQUEO COMPLEMENTADO CON MSP CHILE</b></th>
                        </tr>
                        <tr>
                            <th colspan="6" style="width: 782px;" bgcolor="#CCCCFF"><b>Sección I: Condiciones de
                                trabajo </b></th>
                        </tr>
                        <tr>
                            <th rowspan="2" style="width: 187px;" bgcolor="#CCAFFF">Preguntas sobre los elementos y
                                procesos peligrosos (factores de riesgo) musculoesqueléticos
                            </th>
                            <th colspan="5" style="width: 589px;" bgcolor="#CCAFFF"><b>
                                <center>Regiones</center>
                            </b></th>
                        </tr>
                        <tr>
                            <th style="width: 113px;" bgcolor="#CCAFFF"><b>Cuello, Hombros, Espalda alta</b></th>
                            <th style="width: 113px;" bgcolor="#CCAFFF"><b>Codos, Antebrazo, Manos</b></th>
                            <th style="width: 113px;" bgcolor="#CCAFFF"><b>Pies</b></th>
                            <th style="width: 113px;" bgcolor="#CCAFFF"><b>Rodillas y caderas</b></th>
                            <th style="width: 113px;" bgcolor="#CCAFFF"><b>Espalda baja</b></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>1. ¿La superficie por donde camina en el trabajo es desigual, inclinada, resbaladiza o
                                frágil?
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch1"
                                          :label="`${this.plibel.switch1 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch2"
                                          :label="`${this.plibel.switch2 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch3"
                                          :label="`${this.plibel.switch3 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>2. ¿Para los movimientos en el trabajo o para los materiales de trabajo el espacio es
                                muy estrecho ?
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch4"
                                          :label="`${this.plibel.switch4 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch5"
                                          :label="`${this.plibel.switch5 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch6"
                                          :label="`${this.plibel.switch6 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch7"
                                          :label="`${this.plibel.switch7 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch8"
                                          :label="`${this.plibel.switch8 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>3. ¿Las herramientas y equipos son inadecuadamente diseñados para el trabajador o sus
                                tareas?
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch9"
                                          :label="`${this.plibel.switch9 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch10"
                                          :label="`${this.plibel.switch10 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch11"
                                          :label="`${this.plibel.switch11 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch12"
                                          :label="`${this.plibel.switch12 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch13"
                                          :label="`${this.plibel.switch13 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>4. ¿La altura de la mesa de trabajo es inadecuada?</td>
                            <td>
                                <v-switch v-model="plibel.switch14"
                                          :label="`${this.plibel.switch14 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch15"
                                          :label="`${this.plibel.switch15 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>5. ¿La silla de trabajo es mal diseñada o incorrectamente adaptada?</td>
                            <td>
                                <v-switch v-model="plibel.switch16"
                                          :label="`${this.plibel.switch16 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch17"
                                          :label="`${this.plibel.switch17 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td>6. ¿Si el trabajo se realiza de pie, no hay ninguna posibilidad de sentarse y
                                descansar?
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch18"
                                          :label="`${this.plibel.switch18 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch19"
                                          :label="`${this.plibel.switch19 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch20"
                                          :label="`${this.plibel.switch20 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>7. ¿Es fatigante trabajar de pie con el pedal?</td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch21"
                                          :label="`${this.plibel.switch21 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch22"
                                          :label="`${this.plibel.switch22 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Cuándo trabaja con las piernas se fatiga?, ejemplo:</td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8. Subir repetidamente taburetes o escalones.</td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch23"
                                          :label="`${this.plibel.switch23 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch24"
                                          :label="`${this.plibel.switch24 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch25"
                                          :label="`${this.plibel.switch25 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9. Saltos repetidos, cuclillas o de rodillas prolongadas
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch26"
                                          :label="`${this.plibel.switch26 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch27"
                                          :label="`${this.plibel.switch27 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch28"
                                          :label="`${this.plibel.switch28 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10. Uso más frecuente de una pierna que soporta el
                                cuerpo
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch29"
                                          :label="`${this.plibel.switch29 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch30"
                                          :label="`${this.plibel.switch30 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch31"
                                          :label="`${this.plibel.switch31 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Se repite o se realiza el trabajo de manera sostenida cuando la espalda
                                está?:
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;11. Medianamente flexionada hacia delante</td>
                            <td>
                                <v-switch v-model="plibel.switch32"
                                          :label="`${this.plibel.switch32 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch33"
                                          :label="`${this.plibel.switch33 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12. Muy flexionada hacia adelante</td>
                            <td>
                                <v-switch v-model="plibel.switch34"
                                          :label="`${this.plibel.switch34 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch35"
                                          :label="`${this.plibel.switch35 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13. Inclinada hacia los lados o ligeramente rotada</td>
                            <td>
                                <v-switch v-model="plibel.switch36"
                                          :label="`${this.plibel.switch36 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch37"
                                          :label="`${this.plibel.switch37 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;14. Muy rotada</td>
                            <td>
                                <v-switch v-model="plibel.switch38"
                                          :label="`${this.plibel.switch38 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch39"
                                          :label="`${this.plibel.switch39 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Se repite o se realiza el trabajo de manera sostenida cuando el cuello
                                está?:
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;15. Flexionado hacia adelante</td>
                            <td>
                                <v-switch v-model="plibel.switch40"
                                          :label="`${this.plibel.switch40 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16. Inclinado hacia los lados o ligeramente rotado</td>
                            <td>
                                <v-switch v-model="plibel.switch41"
                                          :label="`${this.plibel.switch41 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;17. Muy rotado</td>
                            <td>
                                <v-switch v-model="plibel.switch42"
                                          :label="`${this.plibel.switch42 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>

                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;18. Extendido hacia atrás</td>
                            <td>
                                <v-switch v-model="plibel.switch43"
                                          :label="`${this.plibel.switch43 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">Al levantar las cargas manualmente, considere los siguientes factores
                                importantes:
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;19. Períodos de levantamiento repetitivos</td>
                            <td>
                                <v-switch v-model="plibel.switch44"
                                          :label="`${this.plibel.switch44 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch45"
                                          :label="`${this.plibel.switch45 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20. Carga pesada</td>
                            <td>
                                <v-switch v-model="plibel.switch46"
                                          :label="`${this.plibel.switch46 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch47"
                                          :label="`${this.plibel.switch47 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;21. Malos agarres de la carga</td>
                            <td>
                                <v-switch v-model="plibel.switch48"
                                          :label="`${this.plibel.switch48 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch49"
                                          :label="`${this.plibel.switch49 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;22. Ubicación muy alta o muy baja de la carga en el inicio
                                o al final de elevación
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch50"
                                          :label="`${this.plibel.switch50 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch51"
                                          :label="`${this.plibel.switch51 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;23. Manipulación más delante del máximo alcance de los
                                brazos
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch52"
                                          :label="`${this.plibel.switch52 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch53"
                                          :label="`${this.plibel.switch53 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;24. Manipulación por debajo de las rodillas</td>
                            <td>
                                <v-switch v-model="plibel.switch54"
                                          :label="`${this.plibel.switch54 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch55"
                                          :label="`${this.plibel.switch55 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;25. Manipulación por encima del nivel de los hombros</td>
                            <td>
                                <v-switch v-model="plibel.switch56"
                                          :label="`${this.plibel.switch56 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch57"
                                          :label="`${this.plibel.switch57 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>26. ¿Es repetitivo, sostenido o incomodo cargar, empujar o tirar cargas?</td>
                            <td>
                                <v-switch v-model="plibel.switch58"
                                          :label="`${this.plibel.switch58 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch59"
                                          :label="`${this.plibel.switch59 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch60"
                                          :label="`${this.plibel.switch60 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>27. ¿Se realiza el trabajo de manera sostenida con un brazo extendido hacia adelante o
                                hacia un lado sin apoyo?
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch61"
                                          :label="`${this.plibel.switch61 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Hay repetición de?:</td>
                        </tr>

                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;28. Movimientos similares en el trabajo</td>
                            <td>
                                <v-switch v-model="plibel.switch62"
                                          :label="`${this.plibel.switch62 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch63"
                                          :label="`${this.plibel.switch63 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;29. Movimientos para el trabajo que sobrepase una
                                distancia cómoda
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch64"
                                          :label="`${this.plibel.switch64 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch65"
                                          :label="`${this.plibel.switch65 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Realiza trabajo manual de manera repetitiva o sostenida en las siguientes
                                circunstancias?:
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;30. Con pesos de los materiales o herramientas de
                                trabajo
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch66"
                                          :label="`${this.plibel.switch66 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch67"
                                          :label="`${this.plibel.switch67 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;31. Con formas incómodas de agarre de los materiales o
                                herramientas de trabajo
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch68"
                                          :label="`${this.plibel.switch68 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch69"
                                          :label="`${this.plibel.switch69 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>

                        <tr>
                            <td>32. ¿Existen altas exigencias de la capacidad visual (objetos pequeños y mala
                                iluminación, más de tres horas sin pausa)?
                            </td>
                            <td>
                                <v-switch v-model="plibel.switch70"
                                          :label="`${this.plibel.switch70 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Se repite la realización del trabajo con los antebrazos y manos en lo
                                siguiente?:
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;33. Haciendo movimientos de torsión</td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch71"
                                          :label="`${this.plibel.switch71 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;34. Haciendo movimientos enérgicos</td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch72"
                                          :label="`${this.plibel.switch72 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;35. En posiciones incómodas de las manos</td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch73"
                                          :label="`${this.plibel.switch73 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;36. Con comandos o teclados</td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch74"
                                          :label="`${this.plibel.switch74 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>

                        <tr>
                            <td>37. ¿Existe flexión, extensión y/o lateralización de la muñeca?</td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch75"
                                          :label="`${this.plibel.switch75 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>38. ¿Realiza movimientos alternativos de la mano con la palma hacia arriba o la palma
                                hacia abajo, utilizando agarres?
                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch76"
                                          :label="`${this.plibel.switch76 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>39. ¿Realiza movimientos forzados utilizando agarre con dedos mientras la muñeca es
                                rotada, ó agarres con abertura amplia de dedos, ó manipulación de objetos?
                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch77"
                                          :label="`${this.plibel.switch77 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>40. ¿Realiza movimientos del brazo hacia delante (flexión) o hacia el lado (abducción o
                                separación) del cuerpo?
                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch78"
                                          :label="`${this.plibel.switch78 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr bgcolor="#CCCCFF">
                            <td colspan="6">¿Levanta o sostiene herramientas, materiales u objetos que pesan más de?:
                            </td>
                        </tr>

                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;41. 0,2 Kg usando los dedos (levantamiento con uso de
                                pinza)
                            </td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch79"
                                          :label="`${this.plibel.switch79 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;42. 2 Kg usando la mano</td>
                            <td>

                            </td>
                            <td>
                                <v-switch v-model="plibel.switch80"
                                          :label="`${this.plibel.switch80 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                        </tr>


                        <tr>
                            <td bgcolor="#CCAFFF"><b>PUNTAJE:</b></td>
                            <td colspan="5"><input id="puntaje1" required="" type="text" name="q1" :value="this.calculo1"></td>
                        </tr>
                        <tr>
                            <td colspan="6"><input type="button" @click="calculoItem1()" value="CALCULAR"></td>
                        </tr>
                        <tr>
                            <td colspan="6" bgcolor="#CCCCFF"><b>Sección II: Ambiente / Factores organizacionales
                                (Modificación)</b></td>
                        </tr>

                        <tr>
                            <td>1. ¿Existe la posibilidad de realizar descansos o pausas?</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch81"
                                          :label="`${this.plibel.switch81 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>2. ¿Hay posibilidad de elegir el orden y tipo de tareas o el ritmo del trabajo?</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch82"
                                          :label="`${this.plibel.switch82 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>3. ¿Se realiza el trabajo bajo las exigencias de tiempo o bajo estrés psicológico?</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch83"
                                          :label="`${this.plibel.switch83 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td bgcolor="#CCAFFF">¿Está presente lo siguiente?:</td>
                            <td bgcolor="#CCAFFF" colspan="5">

                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. Frío</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch84"
                                          :label="`${this.plibel.switch84 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5. Calor</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch85"
                                          :label="`${this.plibel.switch85 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;6. Corrientes de aire</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch86"
                                          :label="`${this.plibel.switch86 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;7. Ruido</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch87"
                                          :label="`${this.plibel.switch87 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;8. Condiciones visuales problemáticas</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch88"
                                          :label="`${this.plibel.switch88 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9. Tirones, sacudidas o vibraciones</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch89"
                                          :label="`${this.plibel.switch89 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>

                        <tr>
                            <td>10. ¿Los equipamientos de protección personal restringen los movimientos o las
                                habilidades del la persona?
                            </td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch90"
                                          :label="`${this.plibel.switch90 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>11. ¿Existe poco apoyo de colegas y supervisores?</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch91"
                                          :label="`${this.plibel.switch91 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>12. ¿Realiza tareas de manera aislada (físicamente) dentro del proceso de producción?
                            </td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch92"
                                          :label="`${this.plibel.switch92 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>13. ¿El ritmo de trabajo es impuesto por la máquina u otras personas?</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch93"
                                          :label="`${this.plibel.switch93 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>14. ¿El ritmo de trabajo o la remuneración están definidos por la cantidad producida?
                            </td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch94"
                                          :label="`${this.plibel.switch94 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td>15. ¿Hay mucho trabajo para las horas definidas, para la jornada de trabajo diaria?</td>
                            <td colspan="5">
                                <v-switch v-model="plibel.switch95"
                                          :label="`${this.plibel.switch95 ? 'Si' : 'No'}`"></v-switch>
                            </td>
                        </tr>
                        <tr>
                            <td bgcolor="#CCAFFF"><b>PUNTAJE:</b></td>
                            <td colspan="5"><input id="puntaje2" required="" type="text" name="q2" :value="this.calculo2"></td>

                        </tr>
                        <tr>
                            <td colspan="6"><input type="button" @click="calculoItem2()" value="CALCULAR"></td>
                        </tr>
                        </tbody>
                    </table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-form>
        <div class="text-xs-center" v-if="plibel!=null">
            <v-btn color="primary" @click="deleteForm" dark>Eliminar Registro</v-btn>
            <v-btn color="primary" @click="savePlibel" dark>Guardar</v-btn>
        </div>
        <v-dialog
                v-model="dialogError"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor verifique la información requerida para continuar.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogError = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialogSuccess"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Se guardó con exito la información</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogSuccess = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import Plibel from "../musculoEsqueletico/Plibel";
    import PlibelJs from "../../../model/Plibel"
    import PatientMonitoring from "../../../model/PatientMonitoring";

    export default {
        data() {
            return {
                calculo1:0,
                calculo2:0,
                plibel: null,
                listPlibel: [],
                valid: true,
                search: '',
                dialogError: false,
                dialogSuccess: false,
            }
        },
        methods: {

            newPlibel() {
                let d = new Date();
                let e = this.formatDate(d);
                this.plibel = new PlibelJs();
                this.plibel.fecha = e
                this.listPlibel.push(this.plibel)
            },

            calculoItem1(){
                this.calculo1 = 0
                this.calculo1 = this.calculo1+(this.plibel.switch1===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch2===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch3===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch4===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch5===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch6===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch7===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch8===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch9===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch10===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch11===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch12===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch13===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch14===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch15===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch16===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch17===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch18===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch19===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch20===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch21===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch22===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch23===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch24===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch25===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch26===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch27===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch28===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch29===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch30===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch31===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch32===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch33===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch34===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch35===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch36===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch37===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch38===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch39===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch40===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch41===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch42===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch43===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch44===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch45===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch46===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch47===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch48===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch49===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch50===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch51===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch52===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch53===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch54===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch55===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch56===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch57===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch58===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch59===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch60===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch61===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch62===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch63===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch64===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch65===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch66===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch67===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch68===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch69===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch70===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch71===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch72===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch73===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch74===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch75===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch76===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch77===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch78===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch79===true?1:0)
                this.calculo1 = this.calculo1+(this.plibel.switch80===true?1:0)
            },

            calculoItem2(){
                this.calculo2 = 0
                this.calculo2 = this.calculo2+(this.plibel.switch81===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch82===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch83===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch84===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch85===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch86===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch87===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch88===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch89===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch90===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch91===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch92===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch93===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch94===true?1:0)
                this.calculo2 = this.calculo2+(this.plibel.switch95===true?1:0)

            },
            loadCalculate(){
                this.calculoItem1();
                this.calculoItem2();
            },
            savePlibel() {
                if (this.$refs.form.validate()) {
                    this.$store.state.patientMonitoringList = []
                    if (this.plibel.id != '' && this.plibel.id != null) {
                        this.$store.dispatch('getPatientMonitoring', this.plibel.id).then(response => {
                            this.$store.state.patientMonitoringOne.value = JSON.stringify(this.plibel)
                            this.$store.dispatch('updatePatientMonitoring', this.$store.state.patientMonitoringOne).then(response => {
                                this.dialogSuccess = true
                                this.reloadData()
                            }, error => {
                                this.$store.state.progress = false
                                this.$store.state.dialogError = true
                            })
                        })
                    } else {
                        let monitoringNew = new PatientMonitoring()
                        monitoringNew.date = new Date()
                        monitoringNew.value = JSON.stringify(this.plibel)
                        monitoringNew.form = 57
                        monitoringNew.patientRouteSheet = this.$store.state.routeSheet
                        this.$store.dispatch('addPatientMonitoring', monitoringNew).then(response => {
                            this.dialogSuccess = true
                            this.reloadData()
                        }, error => {
                            this.$store.state.progress = false
                            this.$store.state.dialogError = true
                        })
                    }
                } else {
                    this.dialogError = true
                }
            },
            deleteForm(){
                confirm('Está seguro de que quiere eliminar el registro?') && this.$store.dispatch('deletePatientMonitoring',this.plibel.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            formatDate(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ":" + seconds + ' ' + ampm;
                return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
            },
            reloadData() {
                let data = new PatientMonitoring()
                data.form = 57
                data.patientRouteSheet = this.$store.state.routeSheet
                data.date = new Date()
                data.value = ""
                this.plibel = null
                this.$store.dispatch('getPatientMonitoringByRouteSheetForm', data).then(response => {
                    this.listPlibel = []
                    for (let i = 0; i < this.$store.state.patientMonitoringList.length; i++) {
                        let anam = JSON.parse(this.$store.state.patientMonitoringList[i].value)
                        anam.id = this.$store.state.patientMonitoringList[i].id
                        this.listPlibel.push(anam)
                    }
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },

        },
        computed: {},
        created() {
            this.reloadData()
        },
    }
</script>

<style scoped>
    v-switch {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/patient/musculoEsqueletico/Plibel.vue